<template>
  <div>
    <GridSyclus
      :idRecursoSistema="args.idRecursoSistema"
      title="Colaboradores"
      :headers="colaboradorHeaders"
      :customHeaders="customHeaders"
      :items="colaboradores"
      item-key="IdColaborador"
      :loading="loading"
      @aplicaFiltros="aplicaFiltros"
      @abreModalGridSyclus="abreModalGridSyclus"
      @changeLayoutSql="changeLayoutSql"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
    />
    <ModalCadastroColaborador 
      v-model="modalColaborador"
      :colaborador="colaborador"
      @colaboradorAdicionado="colaboradorAdicionado"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSyclus from '@/components/shared/GridSyclus';
import Colaborador from '@/domain/colaborador/Colaborador';
import ModalCadastroColaborador from '@/components/colaborador/ModalCadastroColaborador';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'ColaboradoresView',
  components: {
    GridSyclus,
    ModalCadastroColaborador
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100011
      },
      colaboradorHeaders: [
        { text: "ID", value: "IdColaborador" },
        { text: "Nome", value: "Descricao" },
        { text: "Status", value: "Status" }
      ],
      customHeaders: ["Status"],
      loading: false,
      modalColaborador: false,
      colaborador: new Colaborador()
    }
  },
  computed: {
    ...mapGetters(['user', 'colaboradores']),
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'fetchColaboradoresSql',
      'fetchLayoutsSqlUsuario',
      'deleteColaborador',
    ]),
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100011 });
      await this.fetchColaboradoresSql(this.args);
      this.loading = false;
    },
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    abreModalGridSyclus() {
      this.modalColaborador = true;
      this.colaborador = Object.assign({}, new Colaborador());
    },
    editItemSelected(payload) {
      if (payload && payload.IdColaborador) {
        this.colaborador = payload;
        this.modalColaborador = true;
      } else if (payload.length) {
        this.colaborador = payload[payload.length - 1];
        this.modalColaborador = true;
      } else {
        this.showNotification({ text: "Selecione um colaborador para alterar.", status: 'error' });
      }
    },
    deleteItemSelected(payload) {
      if (payload.length) {
        if (confirm(`Tem certeza que deseja excluir: ${payload.length} registros?`)) {
          let promises = [];

          payload.forEach(item => {
            promises.push(this.deleteColaborador(item.IdColaborador));
          });
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os colaboradores: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um colaborador para excluir.', status: 'error' });
      }
    },
    colaboradorAdicionado() {
      this.colaborador = Object.assign({}, new Colaborador());
    }
  },
  created() {
    changePageTitle('Colaboradores');
  }
}
</script>

<style>

</style>